import { render, staticRenderFns } from "./PassoligHistoryComponent.vue?vue&type=template&id=60f9228e&scoped=true"
import script from "./PassoligHistoryComponent.vue?vue&type=script&lang=js"
export * from "./PassoligHistoryComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PassoligHistoryComponent.vue?vue&type=style&index=1&id=60f9228e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9228e",
  null
  
)

export default component.exports